<template>
  <section>
    <resource
      title="Ändern"
      resource="news"
      resourceName="Artikel"
      :original="original"
      :attributes="[
        {
          name: 'title',
          label: 'Titel'
        },
        {
          name: 'article',
          label: 'Artikel',
          type: 'WYSIWYGSelector',
          editorToolbar: [
            { header: [false, 1, 2, 3, 4, 5, 6] },
            'bold',
            'italic',
            'underline',
            'strike',
            'code-block',
            { list: 'ordered' },
            { list: 'bullet' },
            { color: [] },
            { background: [] },
            'clean'
          ]
        },
        {
          name: 'release_time',
          label: 'Veröffentlichungsdatum',
          type: 'DateTimeSelector'
        },
        {
          name: 'read_type',
          label: 'Newscounter',
          type: 'SelectSelector'
        }
      ]"
    >
      <div slot="title">
        <h4>Artikel bearbeiten</h4>
      </div>
    </resource>
  </section>
</template>

<script lang="babel">
import store from "@/store";

export default {
  beforeRouteEnter (to, from, next) {
    store.dispatch('news/read', [
      {
        name: 'where',
        attributes: {
          id : [Number(to.params.id)],
        }
      },
    ]).then(() => {
      next();
    });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters['news/find'](this.id);
    },
  },
}
</script>
